import React from 'react';
import { Menu, Search, Bell, BellOff, User, Loader2, Palette } from 'lucide-react'; // ✅ إضافة Palette
import { useDispatch, useSelector } from 'react-redux';
import { setSearchOpen } from '../../RTK/SearchBare/Searchbar';
import GlobalSearch from './GlobalSearch';
import { useNotifications } from '../../hooks/useNotifications';

function Navbar({ setToggleNav, isCollapsed, isMobileView }) {
  const dispatch = useDispatch();
  const isSearchOpen = useSelector((state) => state.search.isSearchOpen);
  
  const { dailyCardPendingCount, soundEnabled, toggleSound } = useNotifications();

  // ✅ قراءة التصميم الحالي من localStorage
  const [sidebarStyle, setSidebarStyle] = React.useState(() => {
    return localStorage.getItem("sidebarStyle") || "classic";
  });

  // ✅ دالة التبديل
  const handleToggleSidebarStyle = () => {
    const newStyle = sidebarStyle === "classic" ? "modern" : "classic";
    setSidebarStyle(newStyle);
    localStorage.setItem("sidebarStyle", newStyle);
    window.location.reload(); // ✅ إعادة تحميل للتبديل الفوري
  };

  const handleOpenSearch = () => {
    dispatch(setSearchOpen(true));
  };

  const handleCloseSearch = () => {
    dispatch(setSearchOpen(false));
  };

  return (
    <>
      <nav
        className={`
          fixed top-0 z-40 bg-gray-900/95 backdrop-blur transition-all duration-300
          supports-[backdrop-filter]:bg-gray-900/75 border-b border-gray-800
          ${!isMobileView ? (isCollapsed ? 'left-0 lg:right-20' : 'left-0 lg:right-64') : 'left-0 right-0'}
        `}
      >
        <div className="h-16 px-4 sm:px-6">
          <div className="flex items-center justify-between h-full">
            {/* Logo Section */}
            <div className="flex-shrink-0 flex items-center gap-3 group">
              <img
                src="/assets/logo.png"
                alt="logo"
                className="h-8 w-auto transition-transform duration-300 group-hover:scale-110"
              />
              <span className="text-white font-semibold text-lg hidden sm:block">
                Daily Card
              </span>
            </div>

            {/* Search Bar - Desktop */}
            <div className="hidden md:flex flex-1 max-w-lg mx-8">
              <button
                onClick={handleOpenSearch}
                className="relative w-full group"
              >
                <Search className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-gray-400 group-hover:text-gray-300" />
                <div className="w-full bg-gray-800 text-gray-400 pl-10 pr-4 py-2 rounded-lg border border-gray-700 group-hover:border-gray-600 group-hover:text-gray-300 transition-colors text-left">
                  Search...
                </div>
              </button>
            </div>

            {/* Right Section */}
            <div className="flex items-center gap-2 sm:gap-4">
              {/* Mobile Menu Button */}
              <button
                onClick={() => setToggleNav(prev => !prev)}
                className="lg:hidden p-2 rounded-lg bg-gray-800 text-gray-400 hover:text-white hover:bg-gray-700 transition-colors"
              >
                <Menu className="h-5 w-5" />
              </button>

              {/* Search Button - Mobile */}
              <button 
                onClick={handleOpenSearch}
                className="md:hidden p-2 rounded-lg bg-gray-800 text-gray-400 hover:text-white hover:bg-gray-700 transition-colors"
              >
                <Search className="h-5 w-5" />
              </button>

              {/* ✅ Sidebar Style Toggle Button */}
              <button
                onClick={handleToggleSidebarStyle}
                className="p-2 rounded-lg bg-gray-800 text-gray-400 hover:text-white hover:bg-gray-700 transition-colors group relative"
                title={sidebarStyle === "classic" ? "تبديل للتصميم الحديث" : "تبديل للتصميم الكلاسيكي"}
              >
                <Palette className="h-5 w-5" />
                
                {/* Tooltip */}
                <div className="absolute bottom-full left-1/2 -translate-x-1/2 mb-2 px-2 py-1 bg-gray-800 text-white text-xs rounded opacity-0 group-hover:opacity-100 transition-opacity whitespace-nowrap pointer-events-none border border-gray-700">
                  {sidebarStyle === "classic" ? "حديث 🎨" : "كلاسيكي 📋"}
                </div>
              </button>

              {/* Daily Card Notifications */}
              <div className="flex items-center gap-2 px-3 py-1.5 rounded-lg bg-gray-800 border border-blue-500/30">
                <div className="flex items-center gap-2">
                  <Loader2 className="h-4 w-4 text-blue-500 animate-spin" />
                  <div className="hidden sm:flex flex-col">
                    <span className="text-[10px] text-gray-400 leading-tight">Daily Card</span>
                    <span className="text-xs font-bold text-white leading-tight">
                      {dailyCardPendingCount}
                    </span>
                  </div>
                  <span className="sm:hidden text-sm font-bold text-white">
                    {dailyCardPendingCount}
                  </span>
                </div>

                <button
                  onClick={toggleSound}
                  className={`p-1.5 rounded transition-all ${
                    soundEnabled
                      ? "bg-blue-500/20 text-blue-400 hover:bg-blue-500/30"
                      : "bg-gray-700/50 text-gray-400 hover:bg-gray-700"
                  }`}
                  title={
                    soundEnabled
                      ? "إيقاف الإشعارات الصوتية"
                      : "تفعيل الإشعارات الصوتية"
                  }
                >
                  {soundEnabled ? (
                    <Bell className="h-4 w-4 animate-pulse" />
                  ) : (
                    <BellOff className="h-4 w-4" />
                  )}
                </button>
              </div>

              {/* User Profile */}
              <div className="hidden sm:flex items-center gap-3">
                <button className="flex items-center gap-2 p-2 rounded-lg bg-gray-800 text-gray-400 hover:text-white hover:bg-gray-700 transition-colors">
                  <User className="h-5 w-5" />
                  <span className="hidden lg:inline">Profile</span>
                </button>
                <img
                  src="https://avatars.githubusercontent.com/u/124599"
                  alt="User"
                  className="h-8 w-8 rounded-full ring-2 ring-gray-800 hover:ring-yellow-500 transition-colors cursor-pointer"
                />
              </div>
            </div>
          </div>
        </div>
      </nav>

      {isSearchOpen && <GlobalSearch onClose={handleCloseSearch} />}
    </>
  );
}

export default Navbar;